// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"6ba31d78","92":"1724138e","128":"a9194849","312":"a2bbc003","349":"da9215e7","453":"8701dc61","537":"469f3b68","543":"6c58e2a2","590":"40ba11f3","722":"23cbf230","756":"d1a18ba9","957":"0717bbac"}[chunkId] + ".chunk.js";
};